var map = {
	"./BestCrew.png": 6667,
	"./BestDressed.png": 9848,
	"./BestPicture.png": 1976,
	"./CoolestTeam.png": 1630,
	"./Fairplay.png": 4974,
	"./FirstPlace.png": 2321,
	"./SecondPlace.png": 2789,
	"./SmartestTeam.png": 9772,
	"./SocialMediaCompany.png": 4286,
	"./ThirdPlace.png": 3686,
	"./WinnerPetanque.png": 9582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9569;